import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            name: "Login",
            component: Login
        },
        {
            path: "/recuperar-senha",
            name: "recuperar-senha",
            component: () => import("./views/RecuperarSenha.vue")
        },
        {
            path: "/modificar-senha",
            name: "modificar-senha",
            component: () => import("./views/ModificarSenha.vue")
        },
        {
            path: "/cadastro",
            name: "cadastro",
            component: () => import("./views/Cadastro.vue")
        },
        {
            path: "/alterar-cadastro",
            name: "alterar-cadastro",
            component: () => import("./views/AlterarCadastro.vue")
        },
        {
            path: "/livros",
            name: "livros",
            component: () => import("./views/Livros.vue")
        },
        {
            path: "/flippingbook/:id",
            name: "flippingbook",
            component: () => import("./views/Flippingbook.vue")
        }
    ]
})